import Utils from "../utils/utils";

class UserAuditTrailsService extends Utils.EventEmitter {
  GetUserAuditTrails(inputData) {
    return new Promise((resolve, reject) => {
      const body = JSON.stringify({
        get: {
          person_profile_id: inputData.personProfileId || "",
          dst_from: inputData.historyFromDST,
          dst_to: inputData.historyToDST,
        },
      });
      const headers = {
        "Content-Type": "application/json",
        apiKey: inputData.apiKey,
        apiSession: localStorage.getItem("auth_token"),
      };
      fetch(`${window.env.REACT_APP_API_IP}/ns-core/person/audit/trail/get`, {
        method: "post",
        headers,
        body,
      })
        .then((response) => response.json())
        .then((json) => {
          resolve(json);
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") console.log("err ", err);
          reject(
            err.response !== undefined
              ? err.response.data.error_description
              : null
          );
        });
    });
  }
}

const instance = new UserAuditTrailsService();

export default instance;
